const selected = require('./selected');

module.exports = { selected };
